module.exports = __webpack_public_path__ + "9aa46f2c0a477b90bfd2dca8c15b1070.png";